module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/anchor.svg?fd97412adbb097d9e2cf1abeb285e9b4";